export const whatMap = {
  test: {
    title: "Just for Test",
    desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    video: "https://www.w3schools.com/html/mov_bbb.mp4",
  },
  demo: {
    title: "Demo Showcase",
    desc: "This is a demonstration video showcasing our features.",
    video: "https://www.w3schools.com/html/movie.mp4",
  },
  example: {
    title: "Example Video",
    desc: "An example of a video with a brief description.",
    video: "https://www.w3schools.com/html/mov_bbb.mp4",
  },
};
